import blank from './blank.svg';
import audi from './audi.svg';
import bmw from './bmw.svg';
import buick from './buick.svg';
import chevrolet from './chevrolet.svg';
import chrysler from './chrysler.svg';
import ford from './ford.svg';
import gmc from './gmc.svg';
import honda from './honda.svg';
import hummer from './hummer.svg';
import hyundai from './hyundai.svg';
import jaguar from './jaguar.svg';
import jeep from './jeep.svg';
import kia from './kia.svg';
import landrover from './land-rover.svg';
import mercedesbenz from './mercedes-benz.svg';
import mitsubishi from './mitsubishi.svg';
import nissan from './nissan.svg';
import pontiac from './pontiac.svg';
import ram from './ram.svg';
import saab from './saab.svg';
import scion from './scion.svg';
import smart from './smart.svg';
import subaru from './subaru.svg';
import toyota from './toyota.svg';
import volkswagen from './volkswagen.svg';
import volvo from './volvo.svg';
import acura from './acura.svg';
import astonmartin from './aston-martin.svg';
import cadillac from './cadillac.svg';
import infiniti from './infiniti.svg';
import lexus from './lexus.svg';
import lincoln from './lincoln.svg';
import lotus from './lotus.svg';
import maybach from './maybach.svg';
import mazda from './mazda.svg';
import mercury from './mercury.svg';
import mini from './mini.svg';
import bentley from './bentley.png';

export interface Images {
  [key: string]: string;
}

const brands: Images = {
  bentley,
  blank,
  acura,
  astonmartin,
  cadillac,
  infiniti,
  lexus,
  lincoln,
  lotus,
  maybach,
  mazda,
  mercury,
  mini,
  bmw,
  buick,
  hummer,
  jaguar,
  landrover,
  mercedesbenz,
  hyundai,
  kia,
  pontiac,
  saab,
  scion,
  audi,
  chevrolet,
  honda,
  toyota,
  chrysler,
  ford,
  gmc,
  jeep,
  mitsubishi,
  nissan,
  ram,
  smart,
  subaru,
  volkswagen,
  volvo,
};

export default brands;

export const brandOf = (make: string | undefined): string => {
  const keyBrand =
    (make || '').replace(' ', '-').toLocaleLowerCase() || 'blank';
  return brands[keyBrand] || brands.blank;
};

export const brandOfCar = (make: string | undefined): string => {
  if (!make) return brands.blank;

  const makeLowerCase = make.toLowerCase();
  const matchedBrand = Object.keys(brands).find((brand) =>
    makeLowerCase.includes(brand)
  );

  return matchedBrand ? brands[matchedBrand] : brands.blank;
};
